import {
    useEffect,
    useState,
} from 'react';

import api from '../../api/api'

import AdminLayout from "./Components/AdminLayout";
import RecipeModal from "./Components/RecipeModal";
// import RecipeGalleryModal from "./Components/RecipeGalleryModal";
import { IMAGE_URL } from '../../path';


export default function AdminFanRecipes()
{
    const [recipes, setRecipes] =
        useState<any[]>([]);

    const [modalOpen, setModalOpen] =
        useState(false);

    // const [
    //     galleryModalOpen,
    //     setGalleryModalOpen
    // ] = useState(false);

    const [page, setPage] = useState<any>(null);

    const [coverImage, setCoverImage] =
        useState<File | null>(null);

    const [coverPreview, setCoverPreview] =
        useState('');

    const [headerBody, setHeaderBody] =
        useState('');

    const [saving, setSaving] =
        useState(false);

    const [selectedRecipe, setSelectedRecipe] =
        useState<any>(null);

    const getImageUrl = (
        path?: string
    ) => {

        if (!path) {
            return '';
        }

        if (path.startsWith('http')) {
            return path;
        }

        return `${IMAGE_URL}${path}`;
    };

    const loadPage = async () => {

        try {

            const response =
                await api.get('/page-header/fan-recipes');

            const data = response.data.page;

            setPage(data);

            setHeaderBody(
                data?.header_body || ''
            );

            if (data?.cover_image) {

                setCoverPreview(
                    getImageUrl(
                        data.cover_image
                    )
                );
            }

        } catch (error) {

            console.error(error);

        }
    };

    const loadRecipes = async (
        fan: boolean = true
    ) => {

        try {

            const response =
                await api.get(
                    `/recipes?fan=${
                        fan ? 1 : 0
                    }`
                );

            setRecipes(
                response.data
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    useEffect(() => {

        loadRecipes(true);
        loadPage();

    }, []);

    const handlePageSave = async () => {

        try {

            setSaving(true);

            if (coverImage) {

                const formData =
                    new FormData();

                formData.append(
                    'image',
                    coverImage
                );

                await api.post(
                    '/page-header/fan-recipes/cover-image',
                    formData
                );
            }

            await api.put(
                '/page-header/fan-recipes/header-body',
                {
                    header_body: headerBody,
                }
            );

            await loadPage();

            setCoverImage(null);

            alert(
                'Recipes page updated successfully.'
            );

        } catch (error) {

            console.error(error);

            alert(
                'Failed to save changes.'
            );

        } finally {

            setSaving(false);

        }
    };

    const handleSave = async (
        data: any
    ) => {

        try {

            if (
                selectedRecipe
            ) {

                data.append(
                    '_method',
                    'PUT'
                );

                await api.post(

                    `/recipes/${selectedRecipe.id}/details`,

                    data,

                    {
                        headers: {
                            'Content-Type':
                                'multipart/form-data',
                        },
                    }

                );

            } else {

                await api.post(

                    '/recipes',

                    data,

                    {
                        headers: {
                            'Content-Type':
                                'multipart/form-data',
                        },
                    }

                );

            }

            setModalOpen(
                false
            );

            setSelectedRecipe(
                null
            );

            await loadRecipes();

        } catch (
            error: any
            ) {

            console.error(
                error
            );

            alert(

                error?.response
                    ?.data?.message ||

                'Failed to save recipe.'

            );

        }
    };

    const handleDelete = async (
        id: number
    ) => {

        if (
            !window.confirm(
                'Delete this recipe?'
            )
        ) {
            return;
        }

        try {

            await api.delete(
                `/recipes/${id}`
            );

            await loadRecipes();

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    const moveRecipeUp = async (
        index: number
    ) => {

        if (
            index <= 0
        ) {
            return;
        }

        const updated =
            [...recipes];

        [
            updated[index - 1],
            updated[index]
        ] = [
            updated[index],
            updated[index - 1]
        ];

        setRecipes(
            updated
        );

        try {

            await api.post(
                '/recipes/reorder',
                {
                    recipes:
                        updated.map(
                            (
                                recipe,
                                position
                            ) => ({
                                id:
                                recipe.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

            await loadRecipes();

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    const moveRecipeDown = async (
        index: number
    ) => {

        if (
            index >=
            recipes.length - 1
        ) {
            return;
        }

        const updated =
            [...recipes];

        [
            updated[index],
            updated[index + 1]
        ] = [
            updated[index + 1],
            updated[index]
        ];

        setRecipes(
            updated
        );

        try {

            await api.post(
                '/recipes/reorder',
                {
                    recipes:
                        updated.map(
                            (
                                recipe,
                                position
                            ) => ({
                                id:
                                recipe.id,

                                display_order:
                                    position + 1,
                            })
                        ),
                }
            );

            await loadRecipes();

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    return (

        <AdminLayout>

            <div className="page-header">

                <h1>
                    Fan Recipes
                </h1>

                <button
                    className="action-btn"
                    onClick={handlePageSave}
                    disabled={saving}
                >
                    {
                        saving
                            ? 'Saving...'
                            : 'Save Changes'
                    }
                </button>

            </div>

            <div className="admin-card">

                <h2>
                    Cover Image
                </h2>

                {coverPreview && (

                    <img
                        src={coverPreview}
                        alt=""
                        className="image-preview"
                    />

                )}

                <p className="field-hint">
                    Maximum file size: 2MB
                </p>

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {

                        const file =
                            e.target.files?.[0];

                        if (!file) {
                            return;
                        }

                        if (
                            file.size >
                            2 * 1024 * 1024
                        ) {

                            alert(
                                'Image must be 2MB or smaller.'
                            );

                            return;
                        }

                        setCoverImage(file);

                        setCoverPreview(
                            URL.createObjectURL(file)
                        );

                    }}
                />

            </div>

            <div className="admin-card description">

                <label>
                    Header Body
                </label>

                <textarea
                    value={headerBody}
                    onChange={(e) =>
                        setHeaderBody(
                            e.target.value
                        )
                    }
                    rows={8}
                    className="form-control"
                />

            </div>

            <div className="admin-card">

                <div className="page-header">

                    <h2>
                        Fan Recipes
                    </h2>

                    <button
                        className="action-btn"
                        onClick={() => {

                            setSelectedRecipe(
                                null
                            );

                            setModalOpen(
                                true
                            );

                        }}
                    >
                        Add Fan Recipe
                    </button>

                </div>
            </div>

            <table className="users-table">

                <thead>

                <tr>

                    <th>
                        Name
                    </th>

                    <th>
                        Featured
                    </th>

                    <th>
                        Active
                    </th>

                    <th>
                        Actions
                    </th>

                </tr>

                </thead>

                <tbody>

                {recipes.map(
                    (
                        recipe,
                        index
                    ) => (

                        <tr
                            key={
                                recipe.id
                            }
                        >

                            <td>
                                {
                                    recipe.name
                                }
                            </td>

                            <td>
                                {
                                    recipe.featured
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>
                                {
                                    recipe.is_active
                                        ? 'Yes'
                                        : 'No'
                                }
                            </td>

                            <td>

                                <div className="actions">

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveRecipeUp(
                                                index
                                            )
                                        }
                                    >
                                        ▲
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() =>
                                            moveRecipeDown(
                                                index
                                            )
                                        }
                                    >
                                        ▼
                                    </button>

                                    <button
                                        className="edit-btn"
                                        onClick={() => {

                                            setSelectedRecipe(
                                                recipe
                                            );

                                            setModalOpen(
                                                true
                                            );

                                        }}
                                    >
                                        Edit
                                    </button>

                                    {/*<button*/}
                                    {/*    className="edit-btn"*/}
                                    {/*    onClick={() => {*/}

                                    {/*        setSelectedRecipe(*/}
                                    {/*            recipe*/}
                                    {/*        );*/}

                                    {/*        setGalleryModalOpen(*/}
                                    {/*            true*/}
                                    {/*        );*/}

                                    {/*    }}*/}
                                    {/*>*/}
                                    {/*    Gallery*/}
                                    {/*</button>*/}

                                    <button
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(
                                                recipe.id
                                            )
                                        }
                                    >
                                        Delete
                                    </button>

                                </div>

                            </td>

                        </tr>

                    )
                )}

                </tbody>

            </table>

            {modalOpen && (

                <RecipeModal

                    recipe={
                        selectedRecipe
                    }

                    recipes={
                        recipes
                    }

                    isFanRecipe={
                        true
                    }

                    onClose={() => {

                        setModalOpen(
                            false
                        );

                        setSelectedRecipe(
                            null
                        );

                    }}

                    onSave={
                        handleSave
                    }

                />

            )}

            {/*{galleryModalOpen &&*/}
            {/*    selectedRecipe && (*/}

            {/*        <RecipeGalleryModal*/}

            {/*            recipe={*/}
            {/*                selectedRecipe*/}
            {/*            }*/}

            {/*            onClose={() => {*/}

            {/*                setGalleryModalOpen(*/}
            {/*                    false*/}
            {/*                );*/}

            {/*                setSelectedRecipe(*/}
            {/*                    null*/}
            {/*                );*/}

            {/*            }}*/}

            {/*            onUpdate={*/}
            {/*                loadRecipes*/}
            {/*            }*/}

            {/*        />*/}

            {/*    )}*/}

        </AdminLayout>

    );
}
